<template>
  <div class="card-form">
    <PageMain
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
      >
        <template slot-scope="{ form }">
          <b-button
            v-if="allow('E')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="exportFile(form)"
          >
            {{ '导出' }}
            <i class="el-icon-download" />
          </b-button>
        </template>
      </PageHeader>
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: { searchForm: chooseTemplateOptions.searchForm },
      }"
    />
    <EditForm
      v-if="openEditDialogOptions.editFormVisible"
      :visible.sync="openEditDialogOptions.editFormVisible"
      :disabled="openEditDialogOptions.disabled"
      :title="openEditDialogOptions.title"
      :pendingGoodsQualityCode="openEditDialogOptions.pendingGoodsQualityCode"
      :pendingGoodsCode="openEditDialogOptions.pendingGoodsCode"
      @reload="reload"
    ></EditForm>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditForm from '../edit-form'
import ChooseTemplate from '@/views/factory/components/choose-template'

export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, EditForm, ChooseTemplate },
  data() {
    return {
      usePage: true,
      openEditDialogOptions: {
        editFormVisible: false,
        pendingGoodsQualityCode: '',
      },
      chooseTemplateOptions: {
        visible: false,
        templateGroup: 'factory-prodLineQualityRecord',
        searchForm: {},
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .pendingGoodsQualityListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pendingGoodsQualityCode,pendingGoodsCode, menuType }) {
      const types = {
        add: '新增产线质检记录信息',
        edit: '编辑产线质检记录信息',
        detail: '产线质检记录详情',
      }

      this.openEditDialogOptions.editFormVisible = true
      this.openEditDialogOptions.disabled = menuType == 'detail'
      this.openEditDialogOptions.title = types[menuType]
      this.openEditDialogOptions.pendingGoodsQualityCode = pendingGoodsQualityCode
      this.openEditDialogOptions.pendingGoodsCode = pendingGoodsCode
    },
    exportFile(form) {
      this.chooseTemplateOptions.visible = true
      this.chooseTemplateOptions.searchForm = {
        ...form,
      }
    },
  },
}
</script>
